import { ArrowForward } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useParams } from 'react-router-dom'
import { activeAlbumIdVar, drawerVar } from '../../../../../providers/apollo/cache'
import useSelectedAlbums from '../../../hooks/useSelectedAlbums'

interface Props {
  handleClose: () => void
}

export default function AlbumMove({ handleClose }: Props) {
  const { bucketId, albumId } = useParams<{ bucketId: string; albumId: string }>()
  const { selectedAlbums } = useSelectedAlbums()
  const containRootAlbum = Array.from(selectedAlbums.keys()).includes(bucketId as string)

  const handleClick = () => {
    if (!albumId && selectedAlbums.size < 1) return

    if (albumId) activeAlbumIdVar(albumId)
    drawerVar('bucketAlbumMove')
    handleClose()
  }

  return (
    <MenuItem
      color="inherit"
      aria-label="Move Album"
      disabled={containRootAlbum || !(albumId || selectedAlbums.size !== 0)}
      onClick={handleClick}
      id="move-menu-item"
      data-test="move-menu-item"
    >
      <ArrowForward style={{ marginRight: 8 }} /> Move Album
    </MenuItem>
  )
}
